import { H4, Image, Text, XStack, YStack } from '@bounty/creators-design-system'
import { CLOUDINARY_URL, VIDEO_BUCKET_URL } from '../config/env'
import { useVideoPlayerState } from '../provider/videoPlayer'

export type VideoCardProps = {
  video: {
    videoImageUrl: string
    id: string
    videoId: string
    videoUrl: string
    displayName: string | null
    profileName: string
    profileLink: string | null
  }
}

export const VideoCard = ({ video }: VideoCardProps) => {
  const [, setVideoPlayerState] = useVideoPlayerState()

  return (
    <YStack justifyContent="flex-end">
      <YStack
        justifyContent="flex-end"
        p="$2"
        position="relative"
        overflow="hidden"
        borderRadius={'$2'}
        width={146}
        height={219}
        onPress={() => {
          setVideoPlayerState((x) => ({
            ...x,
            videoUrl: `${VIDEO_BUCKET_URL}/${video.videoId}.mp4`,
          }))
        }}
      >
        {/*
        // @ts-expect-error: These types are wrong*/}
        <Image
          position="absolute"
          top={0}
          bottom={0}
          left={0}
          right={0}
          src={`${CLOUDINARY_URL}/video_id_${video.videoId}.jpg`}
        />
        {/* TODO: Play button not showing on web */}
        <YStack
          zIndex={'$2'}
          position="absolute"
          bottom={'$1'}
          left={'$1'}
          backgroundColor="$blackAlpha.500"
          borderRadius={'$2'}
        >
          <H4 color="$neutral.50" numberOfLines={1} size="$sm" px="$3" py="$1">
            Play
          </H4>
        </YStack>
      </YStack>

      <XStack width={146} justifyContent="space-between">
        <Text
          size="$xs"
          color="$neutral.600"
          fontWeight={'$semibold'}
          pr="$1"
          flexShrink={1}
          numberOfLines={1}
        >
          {video.displayName}
        </Text>
      </XStack>
    </YStack>
  )
}
